export function camelCaseToSentenceCase(input: string) {
  return input.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before uppercase letters
}

export function fixLabel(input: string) {
  return camelCaseToSentenceCase(input)
    .replace('Switch | ', '')
    .replace('Switch', '')
    .replace(' List', '');
}
